/* eslint-disable no-unused-vars */
import React, {PureComponent} from 'react';
import { Button, Transition, Icon, Segment, Form, Input } from 'semantic-ui-react'

export default class ControlPanel extends PureComponent {


  render() {

    const { features, drawLine, drawSettings, updateDrawSettings, addToMap, addedToMap, deleteFromMap } = this.props;

    return (

<div>
      <div style={{position: 'absolute', bottom: 50, left: 50, maxWidth: 200, maxHeight: '80%',overflow: 'auto'}}>
      <Segment>
      <Form>
    <Form.Group widths='equal'>
      <Form.Input
        fluid
        label='x Scale'
        value={drawSettings.xFactor}
        onChange={(e, {value}) => updateDrawSettings({xFactor: value})}
      />
    </Form.Group>
    <Form.Group widths='equal'>
      <Form.Input
        fluid
        label='y Scale'
        value={drawSettings.yFactor}
        onChange={(e, {value}) => updateDrawSettings({yFactor: value})}
      />
    </Form.Group>
    <Form.Group widths='equal'>
      <Form.Input
        fluid
        label='y Offset'
        value={drawSettings.yOffset}
        onChange={(e, {value}) => updateDrawSettings({yOffset: value})}
      />
    </Form.Group>
    <Form.Group widths='equal'>
      <Form.Input
        fluid
        label='z Offset'
        value={drawSettings.xOffset}
        onChange={(e, {value}) => updateDrawSettings({xOffset: value})}
      />
    </Form.Group>
    <Form.Group widths='equal'>
      <Form.Input
        fluid
        label='width factor'
        value={drawSettings.widthFactor}
        onChange={(e, {value}) => updateDrawSettings({widthFactor: value})}
      />
    </Form.Group>
  </Form>

        <Button color='twitter' onClick={drawLine} >Draw Line</Button>

</Segment>
      </div>

<div style={{position: 'absolute', bottom: 50, right: 50, maxWidth: 200, maxHeight: '80%',overflow: 'auto'}}>
  {features.length > 1 && <Button color='green' onClick={addToMap} >Add to map</Button>}
      </div>

  <div style={{position: 'absolute', bottom: 100, right: 50, maxWidth: 200, maxHeight: '80%',overflow: 'auto'}}>
    {addedToMap && <Button color='red' onClick={deleteFromMap} >Delete from map</Button>}
        </div>
</div>

    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/Edit/control-panel.js